export const STATUS = {
    SUCCESS: 'success',
    ERROR: 'error',
    ALERT: 'alert',
    INFO: 'info',
};

export const ICONS = {
    success: 'check-circle-outline',
    error: 'cancel',
    alert: 'error',
    info: 'notifications',
};

export const EVENTS = {
    CLOSE: 'close',
    ACTION: 'action',
};

export const POSITION = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
};

export const DEFAULT_POSITION = POSITION.RIGHT;

export const TOAST_GROUP_ID = 'b2b-toasts';

export const TOAST_ID_ATTR = 'data-toast-id';

export const DEFAULT_ICON_SIZE = 'sl';

export function normalizeToastPosition(position) {
    const value = String(position || DEFAULT_POSITION).toLowerCase();

    if (value === POSITION.LEFT || value === POSITION.RIGHT || value === POSITION.CENTER) {
        return value;
    }

    return DEFAULT_POSITION;
}
